import Modal from '../../../../components/Modal';
import PropTypes from 'prop-types';

const DocumentModal = ({ isOpen, onClose, value }) => {
  return (
    <Modal isOpen={isOpen} onClose={onClose} titleName="Document" contentWidth="50%">
      <div className="resource-view" dangerouslySetInnerHTML={{ __html: value }}></div>
    </Modal>
  );
};
  
DocumentModal.propTypes = {
  isOpen: PropTypes.bool,
  onClose: PropTypes.func,
  value: PropTypes.string
};

export default DocumentModal;